import { render, staticRenderFns } from "./Style3.vue?vue&type=template&id=5a4ee3d0"
import script from "./Style3.vue?vue&type=script&lang=js"
export * from "./Style3.vue?vue&type=script&lang=js"
import style0 from "./Style3.vue?vue&type=style&index=0&id=5a4ee3d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports